<div class="banner-wrapper">
  <div class="banner-title">
    <h1 translate>LEARN_MORE_PAGE.BOOST_BUSINESS</h1>
    <p translate>LEARN_MORE_PAGE.SPLIT_PLAN</p>
  </div>
  <div class="partners-start">
    <!-- <a [href]="envService.MerchantURL" target="_blank">  
            <button class="btn btn-black" translate>
                LEARN_MORE_PAGE.PARTNERS_PORTAL
            </button>
        </a> -->
    <button class="btn btn-sky-blue" routerLink="/partner/sign-up" translate>
      LEARN_MORE_PAGE.START_NOW
    </button>
  </div>
  <div class="fund-growth">
    <h4 class="fund-title" translate>LEARN_MORE_PAGE.FUND_GROWTH</h4>
  </div>
  <div class="statistic-count">
    <div>
      <h4 translate>LEARN_MORE_PAGE.COUNT_1</h4>
      <span translate>ORDER_DESC</span>
    </div>
    <div>
      <h4 translate>LEARN_MORE_PAGE.COUNT_2</h4>
      <span translate>INSCREASE_SALES_DESC</span>
    </div>
    <div>
      <h4 translate>LEARN_MORE_PAGE.COUNT_3</h4>
      <span translate>CONVERSION_DESC</span>
    </div>
    <div>
      <h4 translate>LEARN_MORE_PAGE.COUNT_4</h4>
      <span translate>LEARN_MORE_PAGE.COUNT_DESC_4</span>
    </div>
  </div>
</div>
